import api from './api'

export const plansService = {
  getAll: async (params = {}) => {
    const res = await api.get('/vendor-plans/admin/all', { params })
    return res.data.data
  },

  getById: async (id) => {
    const res = await api.get(`/vendor-plans/${id}`)
    return res.data
  },

  create: async (data) => {
    const res = await api.post('/vendor-plans', data)
    return res.data
  },

  update: async (id, data) => {
    const res = await api.patch(`/vendor-plans/${id}`, data)
    return res.data
  },

  delete: async (id) => {
    const res = await api.delete(`/vendor-plans/${id}`)
    return res.data
  },

  getVendors: async (id) => {
    const res = await api.get(`/vendor-plans/${id}/vendors`)
    return res.data.data
  },
}
